module.exports = __webpack_public_path__ + "img/logo_h_green.0d13c075.svg";